export default "__VITE_ASSET__BcQyeJAU__"